import { ProductStatus } from '@parallel-fluidics/shared/models/products';
import {
  doc,
  getFirestore,
  runTransaction,
  serverTimestamp,
} from 'firebase/firestore';

import promoteActiveVersion from './_promoteActiveVersion';

export default async function activateProductVersion({ productDocId, versionId }) {
  const db = getFirestore();
  const productRef = doc(db, 'products', productDocId);
  const targetVersionRef = doc(db, 'products', productDocId, 'versions', versionId);

  await runTransaction(db, async (transaction) => {
    const [productSnapshot, targetVersionSnapshot] = await Promise.all([
      transaction.get(productRef),
      transaction.get(targetVersionRef),
    ]);

    if (!productSnapshot.exists()) throw new Error(`Product not found: ${productDocId}`);
    if (!targetVersionSnapshot.exists()) throw new Error(`Version not found: ${versionId}`);

    const currentActiveId = productSnapshot.data().activeVersionId;

    transaction.set(targetVersionRef, {
      status: ProductStatus.ACTIVE,
      retiredAt: null,
      effectiveAt: serverTimestamp(),
    }, { merge: true });

    promoteActiveVersion(transaction, {
      db,
      productDocId,
      versionId,
      currentActiveId,
      serverTimestamp,
    });
  });
}
